import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { orgUnitsStoreStateSelector } from '~/selectors';

export const useMySpecificUnits = (): {
  aMyManUnits: number[];
  aMyHRUnits: number[];
} => {
  return useSelector((state: StoreState) => {
    return orgUnitsStoreStateSelector(state);
  });
};
